import angular from 'angular';

angular.module('commonServices').factory('objectFactorySvc', ['appSettings', objectFactory]);

function objectFactory(appSettings) {
  var hasType = function(typesArray, type) {
    // if type is in typesArray return true, else return false
    for (var t = 0; t < typesArray.length; t++) {
      if (typesArray[t] === parseInt(type)) return true;
    }
    return false;
  };

  var newLinkObject = function(relId, linkType, targetRelation) {
    // the fields we select need to have targetRelation.type in targetTypes
    var fields = [];
    angular.forEach(linkType.fields, function(field) {
      if (!field.targetTypes || hasType(field.targetTypes, targetRelation.type))
        fields.push(angular.copy(field));
    });

    return {
      fields: fields,
      from: relId,
      isPrincipal: true,
      isRemoved: false,
      label: linkType.labelTo,
      linkType: linkType,
      target: targetRelation,
      to: targetRelation.id,
    };
  };

  var newAddressObject = function(medium, country) {
    var address = {
      id: '00000000-0000-0000-0000-000000000000',
      addressData: null,
      postAddress: null,
      isMain: false,
      medium: medium !== null ? medium : null,
    };
    // Physical address or postbox
    if (medium === 0 || medium === 5)
      address.postAddress = {
        street1: null,
        number: null,
        box: null,
        street2: null,
        zipCode: null,
        city: null,
        region: null,
        country: country || appSettings.defaultCountry,
      };
    return address;
  };

  var newCommObject = function() {
    return {
      addressId: '00000000-0000-0000-0000-000000000000',
      id: '00000000-0000-0000-0000-000000000000', //'00000000-0000-0000-0000-000000000000',
      label: null,
      medium: null,
      purpose: null,
      type: 0,
      assignmentTemplateIds: [],
    };
  };

  return {
    address: newAddressObject,
    commSetting: newCommObject,
    link: newLinkObject,
  };
}
